import type { Graphics as PixiGraphics } from "pixi.js";

export const PARTIAL_PIE_GREEN = 0x28b869;
export const PARTIAL_PIE_RED = 0xff0000;

/** Half-green / half-red occupancy pie. Green is the left half, red the right, matching the legend. */
export function drawPartialOccupancyPie(g: PixiGraphics, radius: number, lineWidth: number): void {
  g.clear();
  g.lineStyle(lineWidth, 0xffffff);
  g.beginFill(PARTIAL_PIE_RED, 1);
  g.moveTo(0, 0);
  g.arc(0, 0, radius, -Math.PI / 2, Math.PI / 2);
  g.closePath();
  g.endFill();
  g.beginFill(PARTIAL_PIE_GREEN, 1);
  g.moveTo(0, 0);
  g.arc(0, 0, radius, Math.PI / 2, (3 * Math.PI) / 2);
  g.closePath();
  g.endFill();
}
